import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";

/**
 * Screen Keyboard Component
 */
@Component({
  selector: "app-screen-keyboard",
  templateUrl: "./screen-keyboard.component.html",
  styleUrls: ["./screen-keyboard.component.scss"],
})
export class ScreenKeyboardComponent implements OnInit {
  /**
   * Position
   */
  @Input() position: string;

  /**
   * Form
   */
  @Input() form: FormGroup;

  /**
   * Key groups
   */
  keyGroups: any[];

  /**
   * Constructor
   *
   * @param elRef ElementRef
   */
  constructor(private elRef: ElementRef) {
    this.keyGroups = [
      /*
      [
        ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', ['<<', 'delete']],
        ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', '@' ],
        ['z', 'x', 'c', 'v', 'b', 'n', 'm', '.', '-', '_' ],
        [['space_bar', 'space']]
      ],*/
      [
        ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P", ["<<", "delete"]],
        ["A", "S", "D", "F", "G", "H", "J", "K", "L", "@"],
        ["Z", "X", "C", "V", "B", "N", "M", ".", "-", "_"],
        [["space_bar", "space"]],
      ],

      [
        ["7", "8", "9"],
        ["4", "5", "6"],
        ["1", "2", "3"],
        ["0", ["<", "before"], [">", "after"]],
      ],
    ];

    this.position = "relative";
  }

  /**
   * ngOnInit
   */
  ngOnInit() {}

  /**
   * Execute key function
   *
   * @param key String or array with icon and function
   */
  inputKey(key: string | []) {
    const focusedElement = this.elRef.nativeElement.ownerDocument.activeElement;

    if (!key) {
      return;
    }

    if (key.length > 1) {
      this[key[1]](focusedElement);
    } else {
      const selection = focusedElement.selectionStart;
      //  if (focusedElement && focusedElement.value) {
      focusedElement.value =
        focusedElement.value.slice(0, selection) +
        key +
        focusedElement.value.slice(selection);
      this.setCaretPosition(focusedElement, selection + 1);
      //  }
    }

    const formNameControl = focusedElement.getAttribute("ng-reflect-name");

    if (formNameControl && this.form) {
      this.form.get(formNameControl).setValue(focusedElement.value);
    }
  }

  /**
   * Delete
   *
   * @param element Input
   */
  delete(element: any) {
    const selection = element.selectionStart;
    element.value =
      element.value.slice(0, selection - 1) + element.value.slice(selection);
    this.setCaretPosition(element, selection - 1);
  }

  /**
   * Space
   *
   * @param element Input
   */
  space(element: any) {
    const selection = element.selectionStart;
    element.value =
      element.value.slice(0, selection) + " " + element.value.slice(selection);
    this.setCaretPosition(element, selection + 1);
  }

  /**
   * Before
   *
   * @param element Input
   */
  before(element: any) {
    this.setCaretPosition(element, element.selectionStart - 1);
  }

  /**
   * After
   *
   * @param element Input
   */
  after(element: any) {
    this.setCaretPosition(element, element.selectionStart + 1);
  }

  /**
   * Set caret position
   *
   * @param ctrl Input
   * @param pos Position
   */
  setCaretPosition(ctrl: any, pos: number) {
    // Modern browsers
    if (ctrl.setSelectionRange) {
      ctrl.focus();
      ctrl.setSelectionRange(pos, pos);

      // IE8 and below
    } else if (ctrl.createTextRange) {
      const range = ctrl.createTextRange();
      range.collapse(true);
      range.moveEnd("character", pos);
      range.moveStart("character", pos);
      range.select();
    }
  }
}
